import { isAxiosError } from 'axios';
import { redactSensitiveParams } from './redactSensitiveParams';

export interface NetworkErrorDescription {
  message: string;
  code?: string;
  method?: string;
  status?: number;
  url?: string;
}

/**
 * What a log line may say about a failed request: never its headers, which carry the Auth0 token,
 * nor its body, and its URL only with credentials such as a share code redacted.
 */
export const describeNetworkError = (error: unknown): NetworkErrorDescription => {
  if (isAxiosError(error)) {
    return {
      message: error.message,
      code: error.code,
      method: error.config?.method,
      status: error.response?.status,
      url: error.config?.url ? redactSensitiveParams(error.config.url) : undefined,
    };
  }
  return { message: error instanceof Error ? error.message : String(error) };
};
